<template>
  <div class="wrapper">
    <!-- Header section -->
    <section class="section-shaped section-lg my-0 section-header">
      <div class="shape shape-style-1 shape-primary">
        <span></span>
        <span></span>
        <span></span>
        <span></span>
        <span></span>
        <span></span>
      </div>
      <div class="container pt-lg-md">
        <div class="row justify-content-center">
          <div class="col-lg-8">
            <h1 class="display-3 text-white text-center">Privacy Policy</h1>
            <p class="lead text-white text-center">Effective Date: May 1, 2025</p>
          </div>
        </div>
      </div>
    </section>

    <!-- Privacy Policy content -->
    <section class="section section-lg pt-lg-0 mt--100">
      <div class="container">
        <div class="row justify-content-center">
          <div class="col-lg-10">
            <card class="border-0" shadow body-classes="py-5 px-5">
              <div class="privacy-content">
                <h2 class="text-primary mb-4">Privacy Policy</h2>
                <p class="disclaimer mb-4"><strong>This service is in no way associated or affiliated with the DVSA, DVLA or any government agencies.</strong></p>

                <p>Zwapit ("us", "we", or "our") operates the Site. This page informs you of our policies regarding the collection, use, and disclosure of personal data when you use our Service and the choices you have associated with that data.</p>
                
                <p>We use your data to provide and improve the Service. By using the Service, you agree to the collection and use of information in accordance with this policy. Unless otherwise defined in this Privacy Policy, terms used in this Privacy Policy have the same meanings as in our Terms and Conditions.</p>

                <div class="mb-5">
                  <h4>1. Definitions</h4>
                  
                  <h5 class="mt-4">Personal Data</h5>
                  <p>Personal Data means data about a living individual who can be identified from those data (or from those and other information either in our possession or likely to come into our possession).</p>
                  
                  <h5 class="mt-4">Usage Data</h5>
                  <p>Usage Data is data collected automatically either generated by the use of the Service or from the Service infrastructure itself (for example, the duration of a page visit).</p>
                  
                  <h5 class="mt-4">Cookies</h5>
                  <p>Cookies are small pieces of data stored on a User's device.</p>
                  
                  <h5 class="mt-4">Data Controller</h5>
                  <p>Data Controller means a person who (either alone or jointly or in common with other persons) determines the purposes for which and the manner in which any personal data are, or are to be, processed. For the purpose of this Privacy Policy, we are a Data Controller of your data.</p>
                  
                  <h5 class="mt-4">Data Processor (or Service Providers)</h5>
                  <p>Data Processor (or Service Provider) means any person (other than an employee of the Data Controller) who processes the data on behalf of the Data Controller. We may use the services of various Service Providers in order to process your data more effectively.</p>
                  
                  <h5 class="mt-4">Data Subject</h5>
                  <p>Data Subject is any living individual who is the subject of Personal Data.</p>
                  
                  <h5 class="mt-4">User</h5>
                  <p>The User is the individual using our Service. The User corresponds to the Data Subject, who is the subject of Personal Data.</p>
                </div>

                <div class="mb-5">
                  <h4>2. Information Collection And Use</h4>
                  <p>We collect several different types of information for various purposes to provide and improve our Service to you.</p>
                  
                  <h5 class="mt-4">Types of Data Collected</h5>
                  
                  <h6 class="mt-3">Personal Data</h6>
                  <p>While using our Service, we may ask you to provide us with certain personally identifiable information that can be used to contact or identify you ("Personal Data"). Personally identifiable information may include, but is not limited to:</p>
                  <ul>
                    <li>Email address</li>
                    <li>First name and last name</li>
                    <li>Full address</li>
                    <li>Phone number</li>
                    <li>Driving licence</li>
                    <li>Driving test details</li>
                    <li>Cookies and Usage Data</li>
                  </ul>
                  
                  <h6 class="mt-3">Usage Data</h6>
                  <p>We may also collect information that your browser sends whenever you visit our Service or when you access the Service by or through a mobile device ("Usage Data").</p>
                  <p>This Usage Data may include information such as your computer's Internet Protocol address (e.g. IP address), browser type, browser version, the pages of our Service that you visit, the time and date of your visit, the time spent on those pages, unique device identifiers and other diagnostic data.</p>
                  <p>When you access the Service by or through a mobile device, this Usage Data may include information such as the type of mobile device you use, your mobile device unique ID, the IP address of your mobile device, your mobile operating system, the type of mobile Internet browser you use, unique device identifiers and other diagnostic data.</p>
                  
                  <h6 class="mt-3">Tracking & Cookies Data</h6>
                  <p>We use cookies and similar tracking technologies to track the activity on our Service and hold certain information. You can read more information about our Cookie Policy.</p>
                  <p>Cookies are files with small amount of data which may include an anonymous unique identifier. Cookies are sent to your browser from a website and stored on your device. Tracking technologies also used are beacons, tags, and scripts to collect and track information and to improve and analyze our Service.</p>
                  <p>You can instruct your browser to refuse all cookies or to indicate when a cookie is being sent. However, if you do not accept cookies, you may not be able to use some portions of our Service.</p>
                  <p>Examples of Cookies we use:</p>
                  <ul>
                    <li><strong>Session Cookies:</strong> We use Session Cookies to operate our Service.</li>
                    <li><strong>Preference Cookies:</strong> We use Preference Cookies to remember your preferences and various settings.</li>
                    <li><strong>Security Cookies:</strong> We use Security Cookies for security purposes.</li>
                  </ul>
                </div>

                <div class="mb-5">
                  <h4>3. Use of Data</h4>
                  <p>Zwapit uses the collected data for various purposes:</p>
                  <ul>
                    <li>To provide and maintain our Service</li>
                    <li>To notify you about changes to our Service</li>
                    <li>To allow you to participate in interactive features of our Service when you choose to do so</li>
                    <li>To provide customer support</li>
                    <li>To gather analysis or valuable information so that we can improve our Service</li>
                    <li>To monitor the usage of our Service</li>
                    <li>To detect, prevent and address technical issues</li>
                  </ul>
                </div>

                <div class="mb-5">
                  <h4>4. Retention of Data</h4>
                  <p>Zwapit will retain your Personal Data only for as long as is necessary for the purposes set out in this Privacy Policy. We will retain and use your Personal Data to the extent necessary to comply with our legal obligations (for example, if we are required to retain your data to comply with applicable laws), resolve disputes, and enforce our legal agreements and policies.</p>
                  <p>Zwapit will also retain Usage Data for internal analysis purposes. Usage Data is generally retained for a shorter period of time, except when this data is used to strengthen the security or to improve the functionality of our Service, or we are legally obligated to retain this data for longer time periods.</p>
                </div>

                <div class="mb-5">
                  <h4>5. Data Transfer</h4>
                  <p>Your information, including Personal Data, may be transferred to — and maintained on — computers located outside of your state, province, country or other governmental jurisdiction where the data protection laws may differ than those from your jurisdiction.</p>
                  <p>If you choose to provide information to us, please note that we transfer the data, including Personal Data, to data centers in the Asia, EU countries and the United States of America and process it there.</p>
                  <p>Your consent to this Privacy Policy followed by your submission of such information represents your agreement to that transfer.</p>
                  <p>Zwapit will take all steps reasonably necessary to ensure that your data is treated securely and in accordance with this Privacy Policy and no transfer of your Personal Data will take place to an organization or a country unless there are adequate controls in place including the security of your data and other personal information.</p>
                </div>

                <div class="mb-5">
                  <h4>6. Data Disclosure</h4>
                  <h5 class="mt-4">Legal Requirements</h5>
                  <p>Zwapit may disclose your Personal Data in the good faith belief that such action is necessary to:</p>
                  <ul>
                    <li>To comply with a legal obligation</li>
                    <li>To protect and defend the rights or property of Zwapit</li>
                    <li>To prevent or investigate possible wrongdoing in connection with the Service</li>
                    <li>To protect the personal safety of users of the Service or the public</li>
                    <li>To protect against legal liability</li>
                  </ul>
                </div>

                <div class="mb-5">
                  <h4>7. Data Security</h4>
                  <p>The security of your data is important to us, but remember that no method of transmission over the Internet, or method of electronic storage is 100% secure. While we strive to use commercially acceptable means to protect your Personal Data, we cannot guarantee its absolute security.</p>
                </div>

                <div class="mb-5">
                  <h4>8. Your Rights</h4>
                  <p>Zwapit aims to take reasonable steps to allow you to correct, amend, delete, or limit the use of your Personal Data.</p>
                  <p>Whenever made possible, you can update your Personal Data directly within your account settings section. If you are unable to change your Personal Data, please contact us to make the required changes.</p>
                  <p>If you wish to be informed what Personal Data we hold about you and if you want it to be removed from our systems, please contact us.</p>
                  <p>In certain circumstances, you have the right:</p>
                  <ul>
                    <li>To access and receive a copy of the Personal Data we hold about you</li>
                    <li>To rectify any Personal Data held about you that is inaccurate</li>
                    <li>To request the deletion of Personal Data held about you</li>
                  </ul>
                  <p>You have the right to data portability for the information you provide to Zwapit. You can request to obtain a copy of your Personal Data in a commonly used electronic format so that you can manage and move it.</p>
                  <p>Please note that we may ask you to verify your identity before responding to such requests.</p>
                </div>

                <div class="mb-5">
                  <h4>9. Service Providers</h4>
                  <p>We may employ third party companies and individuals to facilitate our Service ("Service Providers"), to provide the Service on our behalf, to perform Service-related services or to assist us in analyzing how our Service is used.</p>
                  <p>These third parties have access to your Personal Data only to perform these tasks on our behalf and are obligated not to disclose or use it for any other purpose.</p>
                  
                  <h5 class="mt-4">Analytics</h5>
                  <p>We may use third-party Service Providers to monitor and analyses the use of our Service.</p>
                  <ul>
                    <li><strong>Google Analytics:</strong> Google Analytics is a web analytics service offered by Google that tracks and reports website traffic. Google uses the data collected to track and monitor the use of our Service. This data is shared with other Google services. Google may use the collected data to contextualize and personalize the ads of its own advertising network. For more information on the privacy practices of Google, please visit the Google Privacy & Terms web page: <a href="http://www.google.com/intl/en/policies/privacy/" class="text-primary">http://www.google.com/intl/en/policies/privacy/</a></li>
                  </ul>
                </div>

                <div class="mb-5">
                  <h4>10. USER DATA GDPR</h4>
                  <p>This Site is GDPR compliant.</p>
                  <p>The Site privacy policy (or data protection policy) outlines the procedures we have used to protect our visitors' personal data. We use this General Data Protection Regulation (GDPR) compliant privacy policy for our e-commerce, blog, chatroom or APP's that asks users to disclose personal information. YOU give us your permission to store cookies on your computer. The Site privacy policy aims to make our internet business compliant with UK and EU data privacy laws and covers key issues such as use of personal data, links to other websites, passwords and security.</p>
                </div>

                <div class="mb-5">
                  <h4>11. Payments</h4>
                  <p>We provide paid products and/or services within the Service. In that case, we use third-party services for payment processing (e.g. payment processors).</p>
                  <p>Payment is made to access the services for a certain period of time desired. Because the payment made is for the desired and requested services.</p>
                  
                  <h5 class="mt-4">Zwapit Generic Refund Policy</h5>
                  <p>Thanks for purchasing you access for Zwapit operated by SITE.</p>
                  <p>We offer a full money-back guarantee for all not Matched Swapping Tests made on our SITE. If you accept and Match the swap with another user, no refund will be made by the Site. We consider your Match request with another user as fully accepted with no possibilities to reverse the Match. Read the terms and conditions of The Site for full explanation of the payments and refunds.</p>
                  <p>The Site will not be liable for any refund outside of the terms and conditions you agreed before to use The Site.</p>
                  <p>The payment processor, the third party, is not responsible for the amounts of money paid by to the Site, cannot be considered responsible for your relationship with the Site.</p>
                  <p>We will not store or collect your payment card details. That information is provided directly to our third-party payment processors whose use of your personal information is governed by their Privacy Policy. These payment processors adhere to the standards set by PCI-DSS as managed by the PCI Security Standards Council, which is a joint effort of brands like Visa, Mastercard, American Express and Discover.</p>
                </div>

                <div>
                  <h4>12. Contact Us</h4>
                  <p>In order to resolve a complaint regarding the Site or to receive further information regarding use of the Site, please contact us at:</p>
                  <p><strong>Zwapit is a registered trademark owned by RFI BUSINESS LIMITED</strong></p>
                  <p>Northampton, 35 BillingRoad, NN1 5DQ, United Kingdom</p>
                  <p>Email: <a href="mailto:rfibusiness2025@gmail.com" class="text-primary">rfibusiness2025@gmail.com</a></p>
                  <p class="mt-4">Copyright © 2025 Zwapit<br>Powered by RFI BUSINESS LIMITED</p>
                </div>
              </div>
            </card>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  name: 'Privacy',
  components: {
    Card: () => import('@/components/Card')
  }
};
</script>

<style lang="scss">
.section-shaped {
  position: relative;
  overflow: hidden;

  .shape {
    position: absolute;
    top: 0;
    width: 100%;
    height: 100%;

    &.shape-style-1 {
      span {
        position: absolute;
        
        &:nth-child(1) {
          bottom: -20px;
          left: -40px;
          width: 100px;
          height: 100px;
          opacity: 0.3;
          background: #017cfe;
          border-radius: 50%;
        }
        
        &:nth-child(2) {
          top: 10%;
          right: 10%;
          width: 150px;
          height: 150px;
          opacity: 0.2;
          background: #017cfe;
          border-radius: 50%;
        }
        
        &:nth-child(3) {
          top: 50%;
          right: 50%;
          width: 200px;
          height: 200px;
          background: rgba(1, 124, 254, 0.2);
          border-radius: 50%;
        }
        
        &:nth-child(4) {
          bottom: 50%;
          right: 10%;
          width: 300px;
          height: 300px;
          background: rgba(1, 124, 254, 0.15);
          border-radius: 50%;
        }
        
        &:nth-child(5) {
          bottom: 0;
          right: 0;
          width: 200px;
          height: 200px;
          background: rgba(1, 124, 254, 0.1);
        }
      }
    }

    &.shape-primary {
      background: linear-gradient(150deg, #015cbe 15%, #017cfe 70%, #56a8fe 94%);
    }
  }
}

.privacy-content {
  h4 {
    color: #017cfe;
    margin-top: 2rem;
    margin-bottom: 1rem;
  }

  h5 {
    color: #017cfe;
  }

  ul, ol {
    padding-left: 1.5rem;
  }

  li {
    margin-bottom: 0.5rem;
  }
  
  .disclaimer {
    background-color: rgba(1, 124, 254, 0.1);
    padding: 1rem;
    border-radius: 0.5rem;
  }
}

.bg-gradient-default {
  background: linear-gradient(150deg, #015cbe 15%, #017cfe 70%, #56a8fe 94%) !important;
}

.text-primary {
  color: #017cfe !important;
}
</style> 